import { Injectable, OnInit } from "@angular/core";
import { BehaviorSubject, firstValueFrom } from "rxjs";

import { UserAuthorizationService } from "../../security/services/user-authorization.service";
import { SharedServiceWorkerService } from "../../shared/services/shared-service-worker.service";
import { NotificationsService } from "./notifications.service";

@Injectable({
    providedIn: 'root'
})

export class NotificationsStateService {

    public notificationsCountSubject$ = new BehaviorSubject<number | null>(null);

    private isLoading = false;

    constructor(
        private userAuthorizationService: UserAuthorizationService,
        private notificationsService: NotificationsService,
        private sharedServiceWorkerService: SharedServiceWorkerService
    ) {
        this.registerEvents();
        this.registerLogoutEvent();
    }


    async loadNotificationsAsync(): Promise<void> {

        const notificationsCount = await firstValueFrom(this.notificationsService.getNotificationsCount());

        this.isLoading = false;
        this.notificationsCountSubject$.next(notificationsCount.count);
    }

    private registerLogoutEvent(): void {
        this.userAuthorizationService.user$.subscribe(user => {
            if (user == null) {
                this.notificationsCountSubject$.next(null);
            }
        })
    }


    private registerEvents(): void {

        let lastEmit = 0;
        const EMIT_THRESHOLD = 500; // ms

        // used to update method only once if both events triggers
        const emitUpdate = () => {
            const now = Date.now();
            if (now - lastEmit > EMIT_THRESHOLD) {
                lastEmit = now;
                if (this.userAuthorizationService.user != null) {
                    this.loadNotificationsAsync();
                }
            }
        };

        this.userAuthorizationService.user$.subscribe({
            next: (user) => {
                if (user != null) {
                    emitUpdate();
                }
            }
        });

        this.sharedServiceWorkerService.visibilitychange$.subscribe({
            next: (visibilitychanged: boolean) => {
                if (!visibilitychanged) return;
                emitUpdate();
            }
        });

    }


}
